const { classExists } = require("../helper/class-exists");
const { clickButton } = require("../helper/click-button");

const tripleDetailHandler = (index, buttons, contents) => {
	for (let i = 0; i < contents.length; i++) {
		if (i === index) {
			if (buttons[i].classList.contains("anchor-detail")) {
				buttons[index].classList.remove("btn-grey-light");
			} else {
				buttons[index].classList.remove("btn-outline-secondary-mid");
			}
			buttons[index].classList.add("btn-secondary-mid");
			contents[index].classList.add("is-active");
		} else {
			contents[i].classList.remove("is-active");
			buttons[i].classList.remove("btn-secondary-mid");
			if (buttons[i].classList.contains("anchor-detail")) {
				buttons[i].classList.add("btn-grey-light");
			} else {
				buttons[i].classList.add("btn-outline-secondary-mid");
			}
		}
	}
};

const tripleDetail = () => {
	const elem = document.querySelector(".js-triple-detail");

	classExists(elem);

	const buttons = elem.querySelectorAll(".tab-btn");
	const contents = elem.querySelectorAll(".tab-content");

	for (let i = 0; i < buttons.length; i++) {
		clickButton([buttons[i]], () => {
            tripleDetailHandler(i, buttons, contents);
            window.dispatchEvent(new Event('resize')); // to trigger tableTrader() function
        });
	}
};

const tripleDetailHeight = () => {
	const elem = document.querySelector(".js-triple-detail");

	classExists(elem);

	const contents = elem.querySelectorAll(".tab-content");

	for (let i = 0; i < contents.length; i++) {
		contents[i].removeAttribute("style");
	}

	//get max height
	let highestHeight = 0;
	for (let i = 0; i < contents.length; i++) {
		let contentHeight = contents[i].clientHeight;

		if (!contents[i].classList.contains("is-active")) {
			contents[i].classList.add("is-active");

			contentHeight = contents[i].clientHeight;
			contents[i].classList.remove("is-active");
		}

		if (contentHeight > highestHeight) {
			highestHeight = contentHeight;
		}
	}

    // only apply the height for non broker award tabs
    if (!elem.classList.contains('is-award-tab') && screen.width >= 1440) {
        for (let i = 0; i < contents.length; i++) {
            contents[i].style.height = highestHeight + "px";
        }
    }
};

document.addEventListener("DOMContentLoaded", function () {
	tripleDetailHeight();
	tripleDetail();
});

window.addEventListener(
	"resize",
	function (event) {
		tripleDetailHeight();
	},
	true
);
